module.exports = __webpack_public_path__ + "static/media/della rovere.038592ba.png";